import { render, staticRenderFns } from "./CreateEditCategory.vue?vue&type=template&id=f2715be2&scoped=true"
import script from "./CreateEditCategory.vue?vue&type=script&lang=js"
export * from "./CreateEditCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2715be2",
  null
  
)

export default component.exports